import { createActionTypes } from "lib/utils/createActionTypes";

export default class UsersDucks {
  public static initialState = {
    users: {}
  };

  public static duckName = "Users";

  public static actionTypes: any = createActionTypes(
    {
      getUsers: "get_users".toUpperCase(),
      addUsers: "add_users".toUpperCase()
    },
    UsersDucks.duckName
  );

  public static setUserEvents = (events: any[]) => dispatch => {
    dispatch({
      type: UsersDucks.actionTypes.setUserEvents,
      payload: { events }
    });
  };
  public static getOwnState = state =>
    state[UsersDucks.duckName] || UsersDucks.initialState;
  public static getUsers(state) {
    return this.getOwnState(state).users;
  }

  public static addUsers = (users: any) => dispatch => {
    dispatch({
      type: UsersDucks.actionTypes.addUsers,
      payload: { users }
    });
  };

  public static reducer(state = UsersDucks.initialState, action) {
    switch (action.type) {
      case UsersDucks.actionTypes.addUsers:
        // console.log(action.payload);
        const newUsersState = { ...state.users };
        Object.keys(action.payload.users).forEach(key => {
          const user = action.payload.users[key];
          newUsersState[user.id] = user;
        });
        return {
          users: {
            ...newUsersState
          }
        };
      default:
        return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/ducks/Users.duck.ts